import { useEffect, useState } from "react";
import { MemberLayout } from "../../components/Layouts";
import { api, readUser } from "../../lib/api";
import { ReferralTree, buildTree } from "../../components/ReferralTree";

export default function ReferralTreePage() {
  const user = readUser();
  const [data, setData] = useState({ members: [] });
  useEffect(() => { api.get("/referrals").then((r) => setData(r.data)).catch(() => {}); }, []);
  const root = buildTree(user?.full_name || "You", data.members);
  return (
    <MemberLayout user={user} active="Referral Tree">
      <div className="panel">
        <div className="panel-heading"><div><span className="eyebrow">INTERACTIVE</span><h3>My referral network</h3></div></div>
        <ReferralTree root={root} />
      </div>
    </MemberLayout>
  );
}
